import { groupBy } from '@/common/js/just'
import { AD_MARKETING_SCENE, MARKETING_SUB_GOAL, PLATFORM, SMART_DELIVERY_PLATFORM } from '../model/project-const.js'
import { twoDigit } from './budget/budget-rules.js'
/**
 * @description: 创建类型及账号
 * @return {*}
 */
export const accountFormRules = {
  accounts: [
    {
      validator(rule, value, callback) {
        if (!value?.length) callback(new Error('请选择账号'))
        callback()
      },
      required: true,
      message: '请输入账号',
      trigger: 'blur'
    }
  ]
}

/**
 * @description: 基础信息
 */
export const basicFormRules = {
  project_name: [
    {
      required: true,
      message: '请输入项目名称',
      trigger: 'blur'
    }
  ],
  game_id: [
    {
      required: true,
      validator(rule, value, callback) {
        if (!value.id) {
          callback(new Error('请选择游戏'))
        }

        callback()
      },
      message: '请选择投放应用',
      trigger: 'change'
    }
  ],
  gdtAppid: [
    {
      required: true,
      validator(rule, value, callback) {
        if (!value) {
          callback(new Error('该应用未配置腾讯分包信息，不能使用分包功能，请更换应用或者找相关运营进行配置'))
        }
        callback()
      },
      trigger: 'change'
    }
  ]
}

/**
 * @description: 广告应用与营销目标
 */
export const appFormRules = {
  promoted_object_type: [
    {
      required: true,
      message: '请选择推广目的',
      trigger: 'change'
    }
  ],
  promotedObject: [
    {
      validator(rule, value, callback) {
        if (!value.promoted_object_id) callback(new Error('请选择游戏ID'))
        callback()
      },
      required: true,
      trigger: 'change'
    }
  ]
}

/**
 * @description: v3营销目的及场景
 * @return {*}
 */
export function marketingGoalRules() {
  return {
    promotedObject: [
      {
        validator: (rule, value, callback) => {
          if (!value.promoted_object_id) return callback(new Error('请选择应用ID'))

          // 安卓校验分包id
          if (this.planForm.ch_platform_id === PLATFORM.ANDROID) {
            if (this.planForm?.game_id?.gdtAppid !== value.promoted_object_id) {
              return callback(new Error('与内部选择的游戏对应的应用ID不匹配，请重新选择'))
            }
          }

          callback()
        },
        required: true,
        trigger: 'change'
      }
    ],
    marketing_sub_goal: [
      {
        trigger: ['change'],
        validator: (rule, value, callback) => {
          const { ad_marketing_scene, smart_delivery_platform } = this.planForm
          if (ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART && smart_delivery_platform === SMART_DELIVERY_PLATFORM.GAME_APP) {
            if (value !== MARKETING_SUB_GOAL.NEW_GAME_LAUNCH) {
              return callback(new Error('APP智投推广子目的只支持新游首发'))
            }
          }

          callback()
        }
      }
    ],
    daily_budget: [
      {
        required: true,
        trigger: ['change', 'blur'],
        validator: (rule, value, callback) => {
          const { daily_budget, budget } = this.planForm

          if (budget === 1) {
            const msg = budgetValidtor(daily_budget)
            return msg ? callback(new Error(msg)) : callback()
          }
          callback()
        }
      }
    ]
  }
}

export function budgetValidtor(daily_budget) {
  if (!daily_budget) {
    return '预算不能为空'
  }
  if (isNaN(daily_budget)) {
    return '请输入数字'
  }

  // 保留2为小数
  if (!twoDigit.test(daily_budget)) {
    return '最多保留2位小数'
  }

  if (daily_budget && daily_budget >= 50 && daily_budget <= 40000000) {
    return ''
  }

  return '预算范围 50 ~ 40,000,000元'
}

export function materialTagRules() {
  return {
    name: [
      {
        required: true,
        message: '请输入素材标签名称',
        trigger: 'blur'
      },
      {
        min: 1,
        max: 10,
        message: '长度在1到10个字符',
        trigger: 'blur'
      }
    ],
    cates: [
      {
        validator: (rule, value, callback) => {
          let { l1, l2 } = this.materialTagForm
          l1 = l1.trim()
          l2 = l2.trim()
          if (!l1 && l2) return callback()
          if (l1) {
            if (!l2) return callback(new Error('请输入二级标签'))
            if (l1.length > 10) return callback(new Error('一级标签不能超过10个字符'))
          }

          if (l2) {
            if (!l1) return callback(new Error('请输入一级标签'))
            if (l2.length > 10) return callback(new Error('二级标签不能超过10个字符'))
          }

          callback()
        },
        trigger: 'blur'
      }
    ]
  }
}
function targetRules() {
  return [
    // { required: true, message: '请输入定向名称', trigger: 'blur' },
    {
      required: true,
      validator: (rule, value, callback) => {
        if (!this.targetingForm.name) return callback(new Error('请输入定向名称'))
        const targetGroups = groupBy(this.targetingGroups, (t) => t.name)
        for (const i in targetGroups) {
          if (targetGroups[i].length > 1) {
            return callback(new Error('定向名称不能重复'))
          }
        }
        callback()
      },
      trigger: ['blur', 'change']
    }
  ]
}

export const RULES = {
  accountFormRules,
  basicFormRules,
  appFormRules,
  marketingGoalRules,
  materialTagRules,
  targetRules
}
